/**
 * dealer-map.js — Electripet Dealer Map v4.0
 * Google Maps-style UI with Leaflet + CartoDB Positron tiles
 */
(function () {
  'use strict';

  /* ── SVG pin 工厂（Google Maps 水滴形）── */
  function pinSVG(color, strokeColor) {
    return [
      '<svg viewBox="0 0 27 43" xmlns="http://www.w3.org/2000/svg">',
        '<path d="M13.5 0C6.044 0 0 6.044 0 13.5c0 9.619 13.5 29.5 13.5 29.5S27 23.119 27 13.5C27 6.044 20.956 0 13.5 0z"',
          ' fill="' + color + '" stroke="' + strokeColor + '" stroke-width="1"/>',
        '<circle cx="13.5" cy="13.5" r="5.5" fill="#fff" opacity="0.9"/>',
      '</svg>'
    ].join('');
  }

  var PIN_COLORS = {
    standard: { fill: '#EA4335', stroke: '#C5221F' },   // Google red
    gold:     { fill: '#F9A825', stroke: '#E65100' },   // gold
    active:   { fill: '#1A73E8', stroke: '#1557B0' }    // Google blue (active)
  };

  function makePinIcon(tier, state) {
    var c = state === 'active' ? PIN_COLORS.active
          : tier === 'gold'   ? PIN_COLORS.gold
          : PIN_COLORS.standard;
    var cls = 'dm-pin' + (state ? ' ' + state : '');
    return L.divIcon({
      className: '',
      html: '<div class="' + cls + '">' + pinSVG(c.fill, c.stroke) + '</div>',
      iconSize:    [27, 43],
      iconAnchor:  [13, 43],
      popupAnchor: [0, -46]
    });
  }

  /* ── Popup HTML ── */
  function buildPopupHTML(dealer) {
    var phone   = dealer.phone   ? '<div class="dm-popup-row"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#70757a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>' + dealer.phone + '</div>' : '';
    var address = dealer.address ? '<div class="dm-popup-row"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#70757a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>' + dealer.address + '</div>' : '';
    var dirUrl  = 'https://www.google.com/maps/dir/?api=1&destination=' + dealer.lat + ',' + dealer.lng;
    var websiteBtn = dealer.url ? '<a href="' + dealer.url + '" target="_blank" class="dm-popup-btn"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>Website</a>' : '';
    var phoneBtn  = dealer.phone ? '<a href="tel:' + dealer.phone + '" class="dm-popup-btn"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>Call</a>' : '';

    return [
      '<div class="dm-popup-inner">',
        '<div class="dm-popup-name">' + (dealer.name || 'Dealer') + '</div>',
        dealer.services ? '<div class="dm-popup-category">' + dealer.services + '</div>' : '',
        address,
        phone,
        '<div class="dm-popup-divider"></div>',
        '<div class="dm-popup-actions">',
          '<a href="' + dirUrl + '" target="_blank" class="dm-popup-btn">',
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
            'Directions',
          '</a>',
          websiteBtn,
          phoneBtn,
        '</div>',
      '</div>'
    ].join('');
  }

  /* ── Left panel card HTML ── */
  function buildCardHTML(dealer) {
    var dirUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + dealer.lat + ',' + dealer.lng;
    return [
      '<div class="dm-card-top">',
        '<div class="dm-card-name">' + (dealer.name || 'Dealer') + '</div>',
        dealer.tier === 'gold' ? '<span class="dm-card-badge">GOLD</span>' : '',
      '</div>',
      dealer.services ? '<div class="dm-card-category">' + dealer.services + '</div>' : '',
      dealer.address  ? '<div class="dm-card-addr"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#70757a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>' + dealer.address + '</div>' : '',
      '<div class="dm-card-actions">',
        '<a href="' + dirUrl + '" target="_blank" class="dm-card-btn" onclick="event.stopPropagation()">',
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
          'Directions',
        '</a>',
        dealer.url   ? '<a href="' + dealer.url + '" target="_blank" class="dm-card-btn" onclick="event.stopPropagation()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>Website</a>' : '',
        dealer.phone ? '<a href="tel:' + dealer.phone + '" class="dm-card-btn" onclick="event.stopPropagation()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>Call</a>' : '',
      '</div>'
    ].join('');
  }

  /* ── Main init ── */
  function initDealerMap(sid) {
    var config = window.dealerMapData && window.dealerMapData[sid];
    if (!config) return;

    var mapEl       = document.getElementById('dm-map-' + sid);
    var listEl      = document.getElementById('dm-list-' + sid);
    var searchInput = document.getElementById('dm-search-' + sid);

    if (!mapEl || !listEl || typeof L === 'undefined') return;

    /* 防重复初始化 */
    if (mapEl._leafletMap) { mapEl._leafletMap.remove(); delete mapEl._leafletMap; }

    var dealers     = config.dealers     || [];
    var defaultLat  = config.defaultLat  || 39.5;
    var defaultLng  = config.defaultLng  || -98.0;
    var defaultZoom = config.defaultZoom || 4;

    /* ── Map init with CartoDB Positron (clean, Google-like style) ── */
    var map = L.map(mapEl, { zoomControl: false }).setView([defaultLat, defaultLng], defaultZoom);
    mapEl._leafletMap = map;

    /* Zoom control — bottom right like Google Maps */
    L.control.zoom({ position: 'bottomright' }).addTo(map);

   /* CartoDB Positron tiles — clean minimal style similar to Google Maps */
   
        /* OpenStreetMap tiles — 免费开源，无需 API 密钥，无水印 */
    var tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

    L.tileLayer(tileUrl, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map);



    var markers   = [];
    var activeIdx = null;

    function activateDealer(idx) {
      var cur = markers[idx];
      if (!cur) return;

      /* 取消上一个 */
      if (activeIdx !== null && activeIdx !== idx) {
        var prev = markers[activeIdx];
        if (prev) {
          if (prev.marker) prev.marker.setIcon(makePinIcon(prev.dealer.tier, ''));
          if (prev.card)   prev.card.classList.remove('active');
        }
      }

      activeIdx = idx;

      if (cur.marker) {
        cur.marker.setIcon(makePinIcon(cur.dealer.tier, 'active'));
        cur.marker.openPopup();
        map.panTo([cur.dealer.lat, cur.dealer.lng]);
        map.invalidateSize();
      }

      if (cur.card) {
        cur.card.classList.add('active');
        cur.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function deactivateAll() {
      if (activeIdx !== null) {
        var prev = markers[activeIdx];
        if (prev) {
          if (prev.marker) { prev.marker.setIcon(makePinIcon(prev.dealer.tier, '')); prev.marker.closePopup(); }
          if (prev.card)   prev.card.classList.remove('active');
        }
        activeIdx = null;
      }
    }

    dealers.forEach(function (dealer, i) {
      /* Card */
      var card = document.createElement('div');
      card.className = 'dm-card';
      card.innerHTML = buildCardHTML(dealer);
      card.addEventListener('click', function () { activateDealer(i); });
      listEl.appendChild(card);

      /* Coord guard */
      var hasCoords = !isNaN(dealer.lat) && !isNaN(dealer.lng) &&
                      !(dealer.lat === 0 && dealer.lng === 0);

      if (!hasCoords) {
        markers.push({ marker: null, dealer: dealer, card: card });
        return;
      }

      /* Marker */
      var marker = L.marker([dealer.lat, dealer.lng], {
        icon: makePinIcon(dealer.tier, '')
      }).addTo(map);

      /* Popup */
      marker.bindPopup(buildPopupHTML(dealer), {
        className: 'dm-popup',
        maxWidth: 280,
        minWidth: 240
      });

      marker.on('mouseover', function () {
        if (activeIdx !== i) marker.setIcon(makePinIcon(dealer.tier, 'hovered'));
      });
      marker.on('mouseout', function () {
        if (activeIdx !== i) marker.setIcon(makePinIcon(dealer.tier, ''));
      });
      marker.on('click', function (e) {
        L.DomEvent.stopPropagation(e);
        activateDealer(i);
      });
      marker.on('popupclose', function () {
        if (activeIdx === i) {
          marker.setIcon(makePinIcon(dealer.tier, ''));
          if (card) card.classList.remove('active');
          activeIdx = null;
        }
      });

      markers.push({ marker: marker, dealer: dealer, card: card });
    });

    map.on('click', deactivateAll);

    /* Search */
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var q = this.value.toLowerCase().trim();
        markers.forEach(function (m) {
          var d = m.dealer;
          var match = !q
            || (d.name     && d.name.toLowerCase().includes(q))
            || (d.address  && d.address.toLowerCase().includes(q))
            || (d.services && d.services.toLowerCase().includes(q))
            || (d.bikes    && d.bikes.toLowerCase().includes(q));
          if (m.card)   m.card.style.display = match ? '' : 'none';
          if (m.marker) {
            if (match) { if (!map.hasLayer(m.marker)) m.marker.addTo(map); }
            else        { if (map.hasLayer(m.marker))  map.removeLayer(m.marker); }
          }
        });
      });
    }
  }

  /* ── Entry: wait for Leaflet ── */
  function waitAndInit() {
    if (typeof L === 'undefined') {
      waitAndInit._n = (waitAndInit._n || 0) + 1;
      if (waitAndInit._n < 50) setTimeout(waitAndInit, 100);
      return;
    }
    Object.keys(window.dealerMapData || {}).forEach(initDealerMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }
})();
